import * as React from 'react';
import config from '../../../config';
import { useState } from 'react';
import { GoogleMap, GoogleMapProps, useJsApiLoader } from '@react-google-maps/api';
import { Spinner } from '@blueprintjs/core';

const zoomSteps: boolean = false;

export interface PharmagardeMapProps extends GoogleMapProps {
  children?: JSX.Element[] | JSX.Element;
  gridSize?: number;
  zoomStep?: number;
  initialZoom?: number; //watch out for fitbounds methods that also play with the zoom
  maximalZoom?: number;
  minimalZoom?: number;
}

const PharmagardeMap = (props: PharmagardeMapProps) => {
  const [zoom, setZoom] = useState(props.zoom || 9);
  const [initialZoom, setInitialZoom] = useState(true);
  // const onZoomChanged = useCallback(() => {
  //   if (zoomSteps) {
  //     if (initialZoom) {
  //       setInitialZoom(false);
  //       setZoom(zoom + 0.0001);
  //       return;
  //     }
  //     let newZoom = ((props.forwardedRef as RefObject<GoogleMap>).current as GoogleMap).getZoom();
  //     if (newZoom > zoom) newZoom = zoom + (props.zoomStep || DEFAULT_ZOOM_STEP);
  //     else newZoom = zoom - (props.zoomStep || DEFAULT_ZOOM_STEP);
  //     setZoom(newZoom);
  //     }
  // }, [zoom, initialZoom]);

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: config.googleMapApiKey,
  });

  var propsCopy = {};
  for (const propKey in props) {
    propsCopy[propKey] = props[propKey];
  }
  if (props.initialZoom) {
    propsCopy['defaultZoom'] = props.initialZoom;
    //the line above should be enough but just in case (and to prevent interferences):
    propsCopy['options']['defaultZoom'] = props.initialZoom;
    propsCopy['options']['zoom'] = props.initialZoom;
    propsCopy['zoom'] = props.initialZoom;
  }
  if (props.maximalZoom) {
    propsCopy['options']['maxZoom'] = props.maximalZoom;
    //the line above should be enough but just in case (and to prevent interferences):
    propsCopy['maxZoom'] = props.maximalZoom;
  }
  if (props.minimalZoom) {
    propsCopy['options']['minZoom'] = props.minimalZoom;
    //the line above should be enough but just in case (and to prevent interferences):
    propsCopy['minZoom'] = props.minimalZoom;
  }

  return isLoaded ? <GoogleMap {...propsCopy} zoom={zoom}></GoogleMap> : <Spinner />;
};

const defaultProps = {
  mapContainerStyle: { height: `100%`, width: '100%' },
  options: { gestureHandling: 'cooperative', scaleControl: true, minZoom: 10, maxZoom: 17, scrollwheel: !zoomSteps }, //zoom between 0-18
  gridSize: 20,
} as Partial<PharmagardeMapProps>;

export default (props: PharmagardeMapProps) => (
  <PharmagardeMap {...defaultProps} {...props} center={props.center || defaultProps.center}>
    {props.children}
  </PharmagardeMap>
);
